import { EditorState, Modifier } from 'draft-js';

import { IcPace } from '@/assets/images/svgs';
import { useUserStore } from '@/store/store.user';

interface TimestampButtonProps {
  editorState?: EditorState;
  onChange?: (editorState: EditorState) => void;
}

const formatDate = (date: Date): string => {
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yy = String(date.getFullYear()).slice(-2);
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${mm}/${dd}/${yy} ${hh}:${min}`;
};

const TimestampButton = ({ editorState, onChange }: TimestampButtonProps) => {
  const { user } = useUserStore();
  const badgeNumber =
    user?.profile?.employmentInformation?.badgeNumber || '---';

  const handleClick = () => {
    if (!editorState || !onChange) return;

    const timestamp = formatDate(new Date());
    const textToInsert = `#${badgeNumber} - ${timestamp}: `;

    const contentState = editorState.getCurrentContent();
    const selectionState = editorState.getSelection();

    const newContentState = Modifier.insertText(
      contentState,
      selectionState,
      textToInsert,
    );

    const newEditorState = EditorState.push(
      editorState,
      newContentState,
      'insert-characters',
    );

    onChange(newEditorState);
  };

  return (
    <div
      className="rdw-option-wrapper"
      onClick={handleClick}
      title="Insert timestamp"
    >
      <IcPace className="h-4 w-4" />
    </div>
  );
};

export default TimestampButton;
